export interface Nav_Interface {
  id:number,
  parent:number,
  title:String,
  icon:string,
  link:string,
  count:number,
  selected:boolean,
  visible:boolean,
  new:number,
  child:Array<Nav_Interface>
}

export function Empty_Nav_Interface():Nav_Interface{
  return{
    id:0,
    parent:0,
    title:'',
    icon:'',
    link:'',
    count:0,
    selected:false,
    visible:false,
    new:0,
    child:[]
  }
}
